import { render, staticRenderFns } from "./TsDatastoreDialog.vue?vue&type=template&id=2e77d89c&"
import script from "./TsDatastoreDialog.vue?vue&type=script&lang=ts&"
export * from "./TsDatastoreDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports